export default __webpack_public_path__ + "static/media/customers.3907111e.svg";